import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findPosition = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/position?`+params,
        method: 'GET'
    })
}

export const addPosition = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/position`,
        method: 'POST',
        data: data
    })
}

export const findPositionByDepart = (departId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/position/depart/${departId}`,
        method: 'GET'
    })
}

export const permissionMenusByDepart = (departId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu/permissionMenusByDepart/${departId}`,
        method: 'GET'
    })
}
export const permissionMenusByPosition = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/menu/permissionMenusByPosition/${id}`,
        method: 'GET'
    })
}
export const editPosition = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/position`,
        method: 'PUT',
        data: data
    })
}

export const delPosition = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/position/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}